<template>
	<div>
		<v-timeline-item class="timeline-raport-description mb-3" color="primary">
			<v-layout column>
				<v-flex class="timeline-item-time">
					<div class="d-flex">
						<div style="text-align: left; text-transform: uppercase">{{ getStateWithParam('report_timeline_reported') }}:</div>
						<div>
							{{ data_in }}
						</div>
					</div>
				</v-flex>
				<v-flex class="timeline-item-text">{{ pershkrimi }}</v-flex>
				<v-flex v-if="show_photos" class="timeline-item-images-wrapper" @click="openfotoFullModal('photos')">
					<div class="timeline-item-image" v-for="(photo, index) in photos" :key="index">
						<img class="lazyload" :src="photo" alt />
					</div>
				</v-flex>
			</v-layout>
		</v-timeline-item>

		<v-timeline-item v-if="notes != ''" class="mb-3 timeline-raport-notes" color="primary">
			<v-layout column>
				<v-flex class="timeline-item-time">
					<div class="d-flex">
						<div style="text-align: left; text-transform: uppercase">{{ getStateWithParam('report_timeline_response') }}:</div>
						<div>
							{{ status_date }}
						</div>
					</div>
				</v-flex>
				<v-flex class="timeline-item-text">{{ notes }}</v-flex>
				<v-flex v-if="show_notes_photos" class="timeline-item-images-wrapper" @click="openfotoFullModal('notesphotos')">
					<div class="timeline-item-image" v-for="(photo, nindex) in notesphotos" :key="nindex">
						<img class="lazyload" :src="photo" alt />
					</div>
				</v-flex>
			</v-layout>
		</v-timeline-item>
	</div>
</template>

<script>
export default {
	name: 'TimeLineItem',
	props: {
		pershkrimi: {
			type: [String],
		},
		data_in: {
			type: [String],
		},
		status_date: {
			type: [String],
		},
		notes: {
			type: [String],
		},
		show_photos: {
			type: [Boolean],
		},
		photos: {
			type: [Array],
		},
		show_notes_photos: {
			type: [Boolean],
		},
		notesphotos: {
			type: [Array],
		},
	},
	methods: {
		openfotoFullModal(type) {
			this.$emit('openFoto', { type: type });
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>
